import React, { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import { Spin } from "antd";
import moment from "moment";

import partnersApi from "../../apis/Partners.api";
import { loginAlert } from "../../components/AlertComponent";
import CommunityEachComponent from "../../components/channel/community/communityEach/CommunityEachComponent";
import CommunityModal from "../../components/channel/community/CommunityModal";
import { setLoading } from "../../redux/store/common/commonDuck";

const CommunityList = () => {
	const history = useHistory();
	const dispatch = useDispatch();
	const reduxChannel = useSelector((state) => state.channel.reduxChannel);
	const cUser = useSelector((state) => state.auth.channelUser);
	const isLoading = useSelector((state) => state.common.loading);
	const setIsLoading = (value) => dispatch(setLoading(value));

	const obsRef = useRef(null); //observer Element
	const preventRef = useRef(true); //옵저버 중복 실행 방지
	const endRef = useRef(false); //모든 글 로드 확인
	const [page, setPage] = useState(4); //현재 페이지

	const [communityList, setCommunityList] = useState([]);
	const [selectCommunity, setSelectCommunity] = useState({});
	const [modalShow, setModalShow] = useState(false);
	const [totalCnt, setTotalCnt] = useState(0);

	const [mediaResult, setMediaResult] = useState(null);
	useEffect(() => {
		if (typeof window !== "undefined") {
			const matchQueryList = window.matchMedia("all and (max-width: 768px)");
			setMediaResult(matchQueryList.matches);

			const media = function handleChange(e) {
				setMediaResult(e.matches);
			};

			matchQueryList.addEventListener("change", media);
		}
	}, []);

	const listRef = useRef();

	// console.log(listRef.current.offsetHeight);

	useEffect(() => {
		window.scrollTo({
			top: 0,
			behavior: "smooth",
		});
	}, []);

	useEffect(() => {
		const observer = new IntersectionObserver(obsHandler, { threshold: 0.5 });
		if (obsRef.current) observer.observe(obsRef.current);
		return () => {
			observer.disconnect();
		};
	});

	useEffect(() => {
		if (reduxChannel?.user_id) {
			getCommunityList();
		}
	}, [reduxChannel]);

	const obsHandler = (entries) => {
		//옵저버 콜백함수
		const target = entries[0];
		if (!endRef.current && target.isIntersecting && preventRef.current) {
			//옵저버 중복 실행 방지
			preventRef.current = false; //옵저버 중복 실행 방지
			if (totalCnt >= page) {
				setPage((prev) => prev + 4); //페이지 값 증가
			} else {
				endRef.current = true;
			}
		}
	};

	useEffect(() => {
		// if (totalCnt === 0) {
		//     getCommunity()
		// } else {
		//     if (totalCnt >= page) {
		//         getCommunity()
		//     }
		// }
		getCommunity();
	}, [page]);

	const getCommunity = useCallback(async () => {
		setIsLoading(true);
		let param = {
			influencerId: reduxChannel?.user_id,
			offset: 0,
			pageSize: page,
			pageType: "user",
		};
		const res = await partnersApi.readCommunityList(param);
		if (res.code === 200) {
			setCommunityList(res.result?.communityDTOList);
			preventRef.current = true;
			endRef.current = false;
		}
		setIsLoading(false);
	}, [page]);

	const handleCommunity = (item) => {
		clickCommunityView(item).then((res) => {
			if (res) {
				if (mediaResult) {
					history.push(
						`/together/channel/community/${item.id}?id=${reduxChannel?.influencer_id}`
					);
				} else {
					setModalShow(!modalShow);
					setSelectCommunity(item);
				}
			}
		});
	};

	const getCommunityList = async () => {
		setIsLoading(true);
		let param = {
			influencerId: reduxChannel?.user_id,
			offset: 0,
			pageSize: page,
			pageType: "user",
		};
		const res = await partnersApi.readCommunityList(param);
		if (res.code === 200) {
			setTotalCnt(res.result.totalCnt);
			setCommunityList(res.result?.communityDTOList);
			preventRef.current = true;
			endRef.current = false;
		}
		setIsLoading(false);
	};

	/**
	 * 소통글 클릭 조회 추가
	 * @param item
	 * @returns {Promise<void>}
	 */
	const clickCommunityView = async (item) => {
		if (!cUser?.id) {
			if (reduxChannel?.login_community_menu) {
				loginAlert({ history, reduxChannel });
				return false;
			} else {
				const param = {
					id: item.id,
					updated_by: cUser?.id,
					influencer_id: reduxChannel?.user_id,
				};
				await partnersApi.createViewCommunity(param);
				return true;
			}
		} else {
			const param = {
				// target_type: "community",
				// target_id: item.id,
				// action: "read",
				// created_by: cUser?.id,
				id: item.id,
				updated_by: cUser?.id,
				influencer_id: reduxChannel?.user_id,
			};
			await partnersApi.createViewCommunity(param);
			return true;
		}
	};

	return (
		<div
			className={`channel-wrap channel-home channel-delay`}
			style={{ backgroundColor: "#f8f9fa", height: "100%" }}
		>
			{/*{isLoading && (*/}
			{/*    <Spin style={{*/}
			{/*        position: "fixed", margin: "auto", width: "100%", paddingTop: "2em", zIndex: 90*/}
			{/*    }}/>*/}
			{/*)}*/}
			<div className={`home-body`}>
				<div
					className={`max-width-apply`}
					style={{
						maxWidth: 750,
					}}
				>
					<div className={`home-recommend-horizontal`}>
						<div className={`recommend-title`}>
							<p className={`type-kr`}>소통</p>
							<p className={`title`}>{reduxChannel?.nickname}의 이야기</p>
						</div>
						<CommunityEachComponent
							communityList={communityList}
							handleCommunity={handleCommunity}
						/>
						{/*{communityList?.map((item, idx) => (*/}
						{/*    <div*/}
						{/*        key={`community-${idx}`}*/}
						{/*        className={`home-community-each modal-community community-each-page community-list-content`}*/}
						{/*        onClick={() => handleCommunity(item)}*/}
						{/*        ref={listRef}*/}
						{/*    >*/}
						{/*        <div className={`home-community-content`}>*/}
						{/*            <div className={`community-title-div `}>*/}
						{/*                <p*/}
						{/*                    className={`community-tag`}*/}
						{/*                    style={{backgroundColor: `${item?.background_color}`}}*/}
						{/*                >*/}
						{/*                    {item?.category_name}*/}
						{/*                </p>*/}
						{/*                <p className={`community-title`}>*/}
						{/*                    {item?.title}*/}
						{/*                </p>*/}
						{/*            </div>*/}
						{/*            <div className={`community-footer-div mobile-noShow`}>*/}
						{/*                <p>*/}
						{/*                    좋아요 {item?.like_num ?? 0}*/}
						{/*                </p>*/}
						{/*                <p>·</p>*/}
						{/*                <p>*/}
						{/*                    댓글 {item?.comment_num ?? 0}*/}
						{/*                </p>*/}
						{/*                <p>·</p>*/}
						{/*                <p>*/}
						{/*                    {moment(item?.created_at).format("YYYY.MM.DD")}*/}
						{/*                </p>*/}
						{/*            </div>*/}
						{/*            <div className={`community-body-div`}>*/}
						{/*                <p>*/}
						{/*                    {item?.body?.replace("\n", "")}*/}
						{/*                </p>*/}
						{/*                {((item?.body?.split("\n")?.length - 1) >= 5) && (*/}
						{/*                    <p className={`body-detail`}>*/}
						{/*                        ...자세히보기*/}
						{/*                    </p>*/}
						{/*                )}*/}
						{/*            </div>*/}
						{/*        </div>*/}
						{/*        {!!(item?.communityImageList?.length && reduxChannel?.user_id) && (*/}
						{/*            <>*/}
						{/*                <CommunityImage imageList={item?.communityImageList}/>*/}
						{/*                /!*<div*!/*/}
						{/*                /!*    className={`home-community-image home-mobile-image-group image-list-group`}>*!/*/}
						{/*                /!*    /!*{mediaResult ? (*!/*!/*/}
						{/*                /!*    <>*!/*/}
						{/*                /!*        {item?.communityImageList?.map((img, index) => {*!/*/}
						{/*                /!*            if (index < 3)*!/*/}
						{/*                /!*                return (*!/*/}
						{/*                /!*                    <div className={`mobile-community-image`}*!/*/}
						{/*                /!*                         key={`list-img-${index}`}>*!/*/}
						{/*                /!*                        <img*!/*/}
						{/*                /!*                            src={`${process.env.REACT_APP_S3_HOST}/image/together/community/${reduxChannel?.user_id}/${img?.title}.${img?.img_type}`}*!/*/}
						{/*                /!*                            onError={({currentTarget}) => {*!/*/}
						{/*                /!*                                currentTarget.onerror = null; // prevents looping*!/*/}
						{/*                /!*                                // currentTarget.style.display = "none";*!/*/}
						{/*                /!*                                currentTarget.src = `/assets/images/no-product.png`;*!/*/}
						{/*                /!*                            }}*!/*/}
						{/*                /!*                            alt={`게시판 이미지`}*!/*/}
						{/*                /!*                            style={index === 2 ? {*!/*/}
						{/*                /!*                                    filter: "brightness(0.5)",*!/*/}
						{/*                /!*                                    height: "auto",*!/*/}
						{/*                /!*                                    width: "100%"*!/*/}
						{/*                /!*                                } :*!/*/}
						{/*                /!*                                {*!/*/}
						{/*                /!*                                    height: "auto",*!/*/}
						{/*                /!*                                    width: "100%"*!/*/}
						{/*                /!*                                }}*!/*/}
						{/*                /!*                        />*!/*/}
						{/*                /!*                        {index === 2 && (*!/*/}
						{/*                /!*                            <p>*!/*/}
						{/*                /!*                                더보기*!/*/}
						{/*                /!*                            </p>*!/*/}
						{/*                /!*                        )}*!/*/}
						{/*                /!*                    </div>*!/*/}
						{/*                /!*                )*!/*/}
						{/*                /!*        })}*!/*/}
						{/*                /!*    </>*!/*/}
						{/*                /!*</div>*!/*/}
						{/*            </>*/}
						{/*        )}*/}
						{/*        <div className={`community-footer-div mobile-show`}>*/}
						{/*            <p>*/}
						{/*                좋아요 {item?.like_num ?? 0}*/}
						{/*            </p>*/}
						{/*            <p>·</p>*/}
						{/*            <p>*/}
						{/*                댓글 {item?.comment_num ?? 0}*/}
						{/*            </p>*/}
						{/*            <p>·</p>*/}
						{/*            <p>*/}
						{/*                {moment(item?.created_at).format("YYYY.MM.DD")}*/}
						{/*            </p>*/}
						{/*        </div>*/}
						{/*    </div>*/}
						{/*))}*/}
					</div>
				</div>
				{isLoading && (
					<Spin
						style={{
							position: "fixed",
							margin: "auto",
							width: "100%",
							left: 0,
							right: 0,
							bottom: "2em",
						}}
					/>
				)}

				{/* 건별 콘텐츠 보기 */}
				{modalShow && (
					<CommunityModal
						modalShow={modalShow}
						setModalShow={setModalShow}
						detail={selectCommunity}
						getCommunityList={getCommunityList}
					/>
				)}
			</div>
			{!isLoading && totalCnt < page && !!communityList?.length && (
				<button
					style={{
						width: "100%",
						color: "#868e96",
						padding: "2em",
						backgroundColor: "inherit",
					}}
					onClick={() => {
						window.scrollTo({
							top: 0,
							behavior: "smooth",
						});
					}}
				>
					마지막 게시글입니다. 맨 위로 올라가기
				</button>
			)}
			<div
				ref={obsRef}
				style={{
					height: 30,
				}}
			/>
		</div>
	);
};
export default CommunityList;
